import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as actions from '../actions/users.actions';
import { MwUserApiService } from 'app/services/user-api.service';

@Injectable()
export class UsersEffects {
  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadUsers),
      switchMap(() =>
        this.usersApiService.getUsers().pipe(
          map((items) => actions.loadUsersSuccess({ items })),
          catchError((error) => of(actions.loadUsersFailed({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private usersApiService: MwUserApiService
  ) {}
}
